import { z } from "zod";

export const chatMessageRoleEnum = z.enum(["user", "assistant"]);

export const chatMessageSchema = z.object({
  id: z.string(),
  conversationId: z.string(),
  role: chatMessageRoleEnum,
  parts: z.array(z.any()),
  organizationId: z.string(),
  createdAt: z.date(),
});

export const chatConversationSchema = z.object({
  id: z.string(),
  title: z.string(),
  isPinned: z.boolean(),
  lastMessageAt: z.date(),
  organizationId: z.string(),
  userId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  messages: z.array(chatMessageSchema).optional(),
});

export const createChatConversationSchema = z.object({
  title: z.string({ invalid_type_error: "Title must be a string" }).min(1, { message: "Title cannot be empty" }),
});

export const updateChatConversationSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
  title: z.string().min(1, { message: "Title cannot be empty" }).optional(),
  isPinned: z.boolean().optional(),
});

export const getChatConversationSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const deleteChatConversationSchema = z.object({
  id: z.string({ invalid_type_error: "ID must be a string" }),
});

export const createChatMessageSchema = z.object({
  role: chatMessageRoleEnum,
  parts: z.array(z.any()),
});

/** Persists a whole exchange in one round-trip: creates the conversation on first send. */
export const syncChatMessagesSchema = z.object({
  conversationId: z.string().optional().nullable(),
  title: z.string().min(1).optional(),
  messages: z.array(createChatMessageSchema).min(1, { message: "At least one message is required" }),
});

export type ChatMessageSchema = z.infer<typeof chatMessageSchema>;
export type ChatConversationSchema = z.infer<typeof chatConversationSchema>;
export type ChatMessageRoleType = z.infer<typeof chatMessageRoleEnum>;
export type ZodCreateChatConversationSchema = z.infer<typeof createChatConversationSchema>;
export type ZodUpdateChatConversationSchema = z.infer<typeof updateChatConversationSchema>;
export type ZodGetChatConversationSchema = z.infer<typeof getChatConversationSchema>;
export type ZodDeleteChatConversationSchema = z.infer<typeof deleteChatConversationSchema>;
export type ZodSyncChatMessagesSchema = z.infer<typeof syncChatMessagesSchema>;
